import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Textarea,
    Input,
    useToast
  } from '@chakra-ui/react';
  import { useState } from 'react';
  
  interface Props {
    isOpen: boolean;
    onClose: () => void;
  }
  
  const ModalQuejasSugerencias: React.FC<Props> = ({ isOpen, onClose }) => {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [mensaje, setMensaje] = useState('');
    const toast = useToast();
  
    const handleSubmit = async () => {
      if (!mensaje.trim()) {
        toast({
          title: 'Mensaje requerido',
          description: 'Por favor escribe una queja o sugerencia.',
          status: 'warning',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
  
      try {
        // Aquí se haría el POST real al backend
        console.log({ nombre, correo, mensaje });
  
        toast({
          title: 'Enviado correctamente',
          description: 'Gracias por tu mensaje. Será atendido a la brevedad.',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });
        setNombre('');
        setCorreo('');
        setMensaje('');
        onClose();
      } catch (error) {
        toast({
          title: 'Error al enviar',
          description: 'Intenta nuevamente más tarde.',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
      }
    };
  
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Quejas y Sugerencias</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb={3}>
              <FormLabel>Nombre (opcional)</FormLabel>
              <Input value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </FormControl>
            <FormControl mb={3}>
              <FormLabel>Correo electrónico (opcional)</FormLabel>
              <Input value={correo} onChange={(e) => setCorreo(e.target.value)} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Mensaje</FormLabel>
              <Textarea
                placeholder="Escribe aquí tu queja o sugerencia"
                value={mensaje}
                onChange={(e) => setMensaje(e.target.value)}
                rows={5}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="blue" onClick={handleSubmit}>
              Enviar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
  
  export default ModalQuejasSugerencias;
  